// extracted by mini-css-extract-plugin
export var growableInput = "_8y-0";
export var tagContainer = "_8y-2";
export var textInput = "_8y-1";